// Angular
import { Injectable } from '@angular/core';

// Analytics

// Models
import { ClaimServicesStatus } from '@amfam/claim/post-fnol/services-data-access';
import { ClaimsNavigationPaths } from '@amfam/shared/models';
import { initialStep, Step } from '@amfam/ui-kit';

import { FnolFlowStepTitles } from '../containers/post-fnol.enum';

@Injectable({
  providedIn: 'root'
})
export class PostFnolService {
  constructor() {}

  private stepsToStepModel(array: String[], completed: boolean): Step[] {
    const convertedSteps = [];
    array.forEach(step => {
      const newStep = {
        ...initialStep,
        name: step,
        title: step,
        complete: completed,
        show: true
      };
      convertedSteps.push(newStep);
    });
    return convertedSteps;
  }

  public getEligibleSteps(claimServicesStatus: ClaimServicesStatus, enteringFrom: string) {
    // The canonical order of eligiblity for all services is
    // Report - Repair - Photos - Rental.
    // To decide the order to show, advance through the steps in that order and
    // add them to todo if we have work to do or completed if they're done.
    // We can then link them together in the correct order and return
    const completed = [];
    const todo = [];

    // 1. Report is always the first step and it is always complete
    completed.push(FnolFlowStepTitles.REPORT);

    // 2. First logical check is on status of Repair
    if (!claimServicesStatus.repairSelected && claimServicesStatus.repairEligible) {
      todo.push(FnolFlowStepTitles.REPAIR);
    }

    if (claimServicesStatus.repairSelected) {
      completed.push(FnolFlowStepTitles.REPAIR);
    }

    // 3. Then look at Photos
    if (claimServicesStatus.photosUploaded) {
      completed.push(FnolFlowStepTitles.PHOTOS);
    } else {
      todo.push(FnolFlowStepTitles.PHOTOS);
    }

    // 4. Last step to check is Rental. Even if we aren't eligible, we still show them a call us
    // screen, so we can add it to todo anyways
    if (claimServicesStatus.rentalSelected) {
      completed.push(FnolFlowStepTitles.RENTAL);
    } else {
      todo.push(FnolFlowStepTitles.RENTAL);
    }

    // Now that we have the order of the steps, we need to convert them to the correct object type
    const convertedCompleted = this.stepsToStepModel(completed, true);
    const convertedTodo = this.stepsToStepModel(todo, false);

    // Check what's been completed so far and set the active step. If completed is only of length 1,
    // then that means only Report is done, and it should also be set as the active step

    if (
      convertedCompleted.length === 1 &&
      (enteringFrom.includes('/claims/report-claim-fnol/summary') ||
        enteringFrom.includes(ClaimsNavigationPaths.CLAIM_CREATE_SUMMARY) ||
        enteringFrom.includes(ClaimsNavigationPaths.CLAIM_CREATE_REVIEW))
    ) {
      convertedCompleted[0].active = true;
    } else {
      convertedTodo[0].active = true;
    }

    // Concat the completed and todo steps together, and link each step to the one after
    const convertedSteps = convertedCompleted.concat(convertedTodo);

    convertedSteps.forEach(function (step, index, steps) {
      if (index < steps.length - 1) {
        step.nextStep = steps[index + 1].name;
      }
    });
    return convertedSteps;
  }
}
